import { SupplierTypeEnum } from "@gtpl/shared-models/common-models";

export class IndentRtRequest{
    fromDate:string;
    toDate:string;
    indentCode:string;
    harvestingDate: string;
    supplierType: SupplierTypeEnum;
}